/**
 * @generated SignedSource<<c5d5fb61b608abe19593f6c121a1bed1>>
 * @relayHash 25e47739b775cd1a570f8bbb44cb67de
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f4409eb2d561d13912be26958e73577596c10b86e3eee8cd29aa811873987228

import type { ConcreteRequest } from 'relay-runtime';
export type PageAgentSessionNudgesQuery$variables = {
  aqlQuery: string;
  first: number;
  shardingContext: string;
};
export type PageAgentSessionNudgesQuery$data = {
  readonly agent_sessionAssociationQuery: {
    readonly nodes: ReadonlyArray<{
      readonly agentSession: {
        readonly agent: {
          readonly name: string;
          readonly picture: AGG$URL;
        } | null;
        readonly conversationChannel: {
          readonly id: string | null;
          readonly name: string | null;
          readonly readStatus: boolean | null;
        } | null;
        readonly id: string | null;
        readonly lastStateChangeAt: AGG$Long | null;
        readonly state: string | null;
      } | null;
      readonly invocationType: string | null;
    } | null> | null;
  } | null;
};
export type PageAgentSessionNudgesQuery = {
  response: PageAgentSessionNudgesQuery$data;
  variables: PageAgentSessionNudgesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "aqlQuery"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shardingContext"
},
v3 = [
  {
    "kind": "Variable",
    "name": "aqlQuery",
    "variableName": "aqlQuery"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "shardingContext",
    "variableName": "shardingContext"
  },
  {
    "kind": "Literal",
    "name": "sort",
    "value": "lastStateChangeAt DESC"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "invocationType"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "state"
},
v7 = {
  "kind": "ScalarField",
  "name": "lastStateChangeAt"
},
v8 = {
  "kind": "ScalarField",
  "name": "name"
},
v9 = {
  "kind": "ScalarField",
  "name": "picture"
},
v10 = {
  "args": [
    {
      "kind": "Variable",
      "name": "workspaceAri",
      "variableName": "shardingContext"
    }
  ],
  "concreteType": "AgentConversationChannel",
  "kind": "LinkedField",
  "name": "conversationChannel",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v8/*: any*/),
    {
      "kind": "ScalarField",
      "name": "readStatus"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "PageAgentSessionNudgesQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "AgentSessionAssociationConnection",
        "kind": "LinkedField",
        "name": "agent_sessionAssociationQuery",
        "plural": false,
        "selections": [
          {
            "concreteType": "AgentSessionAssociation",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "concreteType": "AgentSession",
                "kind": "LinkedField",
                "name": "agentSession",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "agent",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v9/*: any*/)
                    ]
                  },
                  (v10/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "PageAgentSessionNudgesQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "AgentSessionAssociationConnection",
        "kind": "LinkedField",
        "name": "agent_sessionAssociationQuery",
        "plural": false,
        "selections": [
          {
            "concreteType": "AgentSessionAssociation",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "concreteType": "AgentSession",
                "kind": "LinkedField",
                "name": "agentSession",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "agent",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v5/*: any*/)
                    ]
                  },
                  (v10/*: any*/)
                ]
              },
              (v5/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "25e47739b775cd1a570f8bbb44cb67de",
    "id": "f4409eb2d561d13912be26958e73577596c10b86e3eee8cd29aa811873987228",
    "metadata": {},
    "name": "PageAgentSessionNudgesQuery",
    "operationKind": "query",
    "text": "query PageAgentSessionNudgesQuery($aqlQuery:String!,$shardingContext:String!,$first:Int!){agent_sessionAssociationQuery(aqlQuery:$aqlQuery,shardingContext:$shardingContext,first:$first,sort:\"lastStateChangeAt DESC\"){nodes{invocationType,agentSession{id,state,lastStateChangeAt,agent{__typename,name,picture,id},conversationChannel(workspaceAri:$shardingContext)@optIn(to:[\"AgentConversationChannelTeamEu26DemoOnly\"]){id,name,readStatus}},id}}}"
  }
};
})();

(node as any).hash = "a71f88d09e31366dcbb8bb6fca3a05a4";

export default node;
